// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".media__cards[data-v-13ee2fdc]{display:grid;grid-gap:.75rem;gap:.75rem}.media__btn[data-v-13ee2fdc]{border-radius:12px}.media__btn[data-v-13ee2fdc]:hover{background-color:var(--v-primary-hover-base)!important}.media__btn[data-v-13ee2fdc]:active{background-color:var(--v-primary-active-base)!important}.media__icon[data-v-13ee2fdc]{border-radius:50%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
